import {useNavigate} from 'react-router-dom';
import {getMemberTermsMstList} from "../../api/termsApi";
import {useEffect, useState} from 'react';
import {TermsTypes} from "../../types/terms.types";

export default function TermsList() {
    const navigate = useNavigate();
    const [termsList, setTermsList] = useState<TermsTypes[]>([]);

    const getTermsMstList = async () => {
        try {
            const result = await getMemberTermsMstList();
            if (result.data.code == "00") {
                setTermsList(result.data.data);
            }
        } catch (err) {
            console.error(err);
        }
    };

    const goTermsDetail = (termsGroupCode: string) => {
        navigate('/terms/termsDetail',{
            state :{
                termsGroupCode
            }
        });
    }


    useEffect(() => {
        getTermsMstList();
    }, []);

    return (
        <>
            <main className="container no-bottom-nav type_gray">
                <section className="bg-white">
                    <ul className="board-list">

                        {termsList?.map((item: TermsTypes, index: number) => {
                            return (
                                <li key={index}>
                                    <a onClick={() => goTermsDetail(item.termsGroupCode)}>
                                        <p className="txt">
                                            <span className="tit">{item.termsName}</span>
                                        </p>
                                        <span className="ico"><i className="fa fa-angle-right" aria-hidden="true"></i></span>
                                    </a>
                                </li>
                            );
                        })
                        }
                    </ul>
                </section>
            </main>
        </>
    )

};